export default __webpack_public_path__ + "static/media/gameWindow.c68a9724.png";